import React from 'react';

const Preloader2 = () => {
    return ( 
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>   
     );
}
 
export default Preloader2;